import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import API from "../Service/Baseservice";
import "../Admin/Admin.css";
import { Eye, EyeOff } from "lucide-react"; // 👈 import icons

const ContactusformView = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const page = location.state?.page || 1;
    const adminData = location.state?.adminData || {};
    const [admin, setAdmin] = useState(adminData || {});
    const [previewImage, setPreviewImage] = useState("");
    const [showPassword, setShowPassword] = useState(false); // 👈 state for visibility toggle

    // ✅ Fetch data from backend if not passed from previous page
    useEffect(() => {
        if (!adminData?.form_id) {
            API.post("contactusform_view", { id })
                .then((res) => {
                    const data = res.data;

                })
            // .catch((err) => console.error("Failed to fetch admin:", err));
        }
    }, [id, adminData]);

    return (
        <div className="admin-form-container">
            <div className="newsadd-header">
                <h2 className="newsadd-title">View Contact us Form</h2>
                <div className="header-buttons">
                    <button onClick={() => navigate("/contactusform", { state: { page } })} className="cancel-btn ">
                        Back
                    </button>
                </div>
            </div>

            <form className="admin-form-page">

                {/* ===== Row 1: Name + Email ===== */}
                <div className="admin-form-row">
                    <div className="admin-form-group">
                        <label>First Name</label>
                        <input
                            type="text"
                            name="admin_name"
                            value={admin.first_name || ""}
                            readOnly
                        />
                    </div>
                    <div className="admin-form-group">
                        <label>Last Name</label>
                        <input
                            type="text"
                            name="text"
                            value={admin.last_name || ""}
                            readOnly
                        />
                    </div>
                </div>

                {/* ===== Row 2: Password + Phone ===== */}
                <div className="admin-form-row">
                    <div className="admin-form-group">
                        <label>Email</label>
                        <div className="password-input-wrapper">
                            <input
                                type="email"
                                name="email"
                                value={admin.email || ""}
                                readOnly
                            />
                        </div>
                    </div>

                    <div className="admin-form-group">
                        <label>Label</label>
                        <div className="password-input-wrapper">
                            <input
                                type="text"
                                name="text"
                                value={admin.label || ""}
                                readOnly
                            />
                        </div>
                    </div>
                </div>

                <div className="admin-form-row">
                    <div className="admin-form-group">
                        <label>Message</label>
                        <input
                            type="text"
                            name="phone_number"
                            value={admin.message || ""}
                            readOnly
                        />
                    </div>
                </div>
            </form>
        </div>
    );
};

export default ContactusformView;
